import { client } from '@/client';

// 获取ConsumerGroup概览
export function getConsumerGroupOverview(clusterName) {
  return client.get(`/api/console/kop/consumerGroup/${clusterName}/overview`);
}

// topic列表服务端
export function getConsumerGroupList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/console/kop/consumerGroup/list/${clusterName}`, others);
}

// 图表接口
export function getConsumerGroupChartData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/kop/consumergroup/${clusterName}`, others);
}

// 获取ConsumerGroup详情topic列表
export function getConsumerGroupDetailList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/console/kop/consumerGroup/getDetailList/${clusterName}`, others);
}

// 图表接口-分区(总体传-1)
export function getTopicPartitionChartData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/kop/consumergroup/topic/partition/${clusterName}`, others);
}

// 重置offset
export function resetOffsets(params) {
  return client.put(`/api/resource/kop/consumergroup/topic/resetOffsets`, params);
}
